import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { useFormHook } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import {
  getDefaultValueByQuestionId,
  saveEddQuestionToLocalStore,
} from '@Pages/happyFlowPages/eddQuestions/shared.utils';
import { EDD_VERSION } from '@Pages/happyFlowPages/eddQuestions/consts';
import { useBoundStore } from '@Store/useBoundStore';
import { useNavigationManager } from '@Router/useNavigationManager';
import { RoutesMap } from '@Router/router.types';
import { usePostEddData } from '@Pages/happyFlowPages/eddQuestions/hooks/usePostEddData';

export const useBusinessSizeLogic = () => {
  const { mutateAsync: postEddData, isPending: isPostingEddData } = usePostEddData();
  const { getEddEmbeddedQuestions } = useBoundStore((state) => state);
  const { navigateToNextPage } = useNavigationManager();
  const { t } = useTranslation('eddQuestions');

  const formMethods = useFormHook({
    schemaTitle: 'Business Size',
    formDefaultValues: {
      [EddEmbeddedFields.EDD_BUSINESS_SIZE]:
        getDefaultValueByQuestionId(EddEmbeddedFields.EDD_BUSINESS_SIZE) || '1-5',
    },
    formSchema: z.object({
      [EddEmbeddedFields.EDD_BUSINESS_SIZE]: z
        .string()
        .min(1, { message: 'Business size is required' }),
    }),
  });

  const handleSubmit = async () => {
    /** Save to local store */
    saveEddQuestionToLocalStore({
      question: t('organic.businessSize.subtitle'),
      questionId: EddEmbeddedFields.EDD_BUSINESS_SIZE,
      answer: formMethods.getValues(EddEmbeddedFields.EDD_BUSINESS_SIZE),
    });

    /** Save to Server */
    try {
      await postEddData({
        version: EDD_VERSION,
        results: getEddEmbeddedQuestions(),
      });
      navigateToNextPage(RoutesMap.EDD_BUSINESS_SIZE);
    } catch (error) {
      /** TODO: Handle error - Check with PM */
      console.error(error);
    }
  };

  return {
    formMethods,
    handleSubmit,
    isLoading: isPostingEddData,
  };
};
